import { getShapeConfig } from "~/telestrations/constants/shapes";
import { SVG_ROTATE_REGEX, SVG_SCALE_REGEX } from "~/telestrations/constants/svgRegex";
import { type Shape, ShapeType } from "~/telestrations/types/canvas";

/**
 * Parses an SVG <text> element into a Shape configuration, with support for background.
 * @param svgElement - The SVG element to parse.
 * @param fill - The fill color of the text.
 * @param background - The background color of the text.
 * @returns A Shape configuration or null if the element is invalid.
 */
export function parseSvgTextElement(svgElement: Element, fill: string, layerIndex: number, background?: string): Shape | null {
  const xSVG = parseFloat(svgElement.getAttribute("x") || "0");
  const ySVG = parseFloat(svgElement.getAttribute("y") || "0");
  const fontSize = parseFloat(svgElement.getAttribute("font-size") || "12");
  if (Number.isNaN(xSVG) || Number.isNaN(ySVG) || Number.isNaN(fontSize)) {
    console.warn(`Invalid attributes for text element: ${svgElement.outerHTML}`);
    return null;
  }

  const transformAttr = svgElement.getAttribute("transform") || "";
  let scaleX = 1,
    scaleY = 1;
  const scaleMatch = transformAttr.match(SVG_SCALE_REGEX);
  if (scaleMatch) {
    scaleX = parseFloat(scaleMatch[1]);
    scaleY = scaleMatch[2] ? parseFloat(scaleMatch[2]) : scaleX;
  }

  let rotation = 0;
  const rotateMatch = transformAttr.match(SVG_ROTATE_REGEX);
  if (rotateMatch) {
    rotation = parseFloat(rotateMatch[1]);
  }

  const x = xSVG * scaleX;
  const y = ySVG * scaleY;
  const fontFamily = svgElement.getAttribute("font-family") || "Arial";
  const align = svgElement.getAttribute("text-anchor") || "start";
  const textContent = svgElement.textContent || "";

  return getShapeConfig(
    {
      id: String(Math.random()),
      type: ShapeType.Text,
      startX: x,
      startY: y,
      layerIndex,
    },
    {
      x,
      y,
      fill,
      text: textContent,
      fontSize,
      fontFamily,
      align,
      rotation,
      scaleX,
      scaleY,
      background,
    }
  );
}
